import * as React from "react";
import { FieldProps } from "formik";
import { cx, css } from "@emotion/css";
import { navigate } from "../support/hashRouting";
import { commonFirmsNames } from "../support/commonFirmsNames";
import { SelectableButton } from "./SelectableButton";
import { FormValues } from "../support/FormValues";
import bootstrapStyles from "../css/bootstrap.module.css";
import { camelize } from "../support/camelize";

const ulStyles = css`
  list-style-type: none;
  padding: 0;
  margin-top: 1em;
`;
const buttonStyle = css`
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
`;

export const FieldCommonFirms = ({
  field,
  form: { touched, errors, setFieldValue }
}: FieldProps<FormValues>) => {
  const onOptionClick = (name: string) => {
    setFieldValue(field.name, name);
    navigate("/transferDetails");
  };

  return (
    <div className={bootstrapStyles["col-md-8"]}>
      <div className={bootstrapStyles.row}>
        <label htmlFor="commonFirmSelector">
          Select from common firms:
          <ul className={ulStyles} id="commonFirmSelector">
            {commonFirmsNames.map((name, index) => {
              return (
                <li
                  key={name}
                  id={`listItem${index}`}
                  className={cx(
                    bootstrapStyles["col-md-4"],
                    bootstrapStyles["col-sm-6"],
                    bootstrapStyles["col-xs-6"],
                    buttonStyle
                  )}
                >
                  <SelectableButton
                    onClick={() => {
                      onOptionClick(name);
                    }}
                    text={name}
                    id={`${camelize(name)}Button`}
                  />
                </li>
              );
            })}

            <li
              className={cx(
                bootstrapStyles["col-md-4"],
                bootstrapStyles["col-md-offset-4"],
                bootstrapStyles["col-sm-4"],
                bootstrapStyles["col-sm-offset-4"],
                bootstrapStyles["col-xs-12"],
                buttonStyle
              )}
            >
              <SelectableButton
                onClick={() => {
                  onOptionClick("");
                }}
                text="Other"
                id={`${camelize("Other")}Button`}
              />
            </li>
          </ul>
        </label>
      </div>
    </div>
  );
};

export default FieldCommonFirms;
